module.exports = __webpack_public_path__ + "static/img/2.090ce153.jpg";